import { IOpenGymReservationsParams } from "../types";
import { useQuery } from "@tanstack/react-query";
import { QUERY_CONSTANTS } from "../queryKeys";
import { IOpenGymReservation } from "../../models/OpenGymReservation";
import { OpenGymReservationService } from "../../services/open-gym-reservation.service";

export const useGetAllOpenGymReservationsQuery = (data: IOpenGymReservationsParams) => {
  return useQuery<IOpenGymReservation[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_GYM_OPEN_GYM_RESERVATIONS, data],
    queryFn: () => OpenGymReservationService.getAll(data).then((res) => res.data),
  });
};
